import { BOM, BOMComponent, BOMRouting } from "@/types/bom";

// Mock BOM data
export const MOCK_BOMS: BOM[] = [
  {
    id: "1",
    bomNumber: "BOM-001",
    parentItemCode: "DESK-001",
    parentItemName: "Executive Desk",
    parentItemDescription: "Premium executive desk with drawers",
    version: "1.0",
    status: "active",
    effectiveDate: new Date("2024-01-01"),
    expiryDate: null,
    bomType: "manufacturing",
    baseQuantity: 1,
    unitOfMeasure: "Each",
    components: [
      {
        id: "c1",
        lineNumber: 10,
        componentCode: "WOOD-OAK-001",
        componentName: "Oak Wood Panel",
        componentDescription: "Premium oak wood panel 2000x800mm",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 85.00,
        totalCost: 85.00,
        scrapPercentage: 5,
        isOptional: false,
        leadTimeDays: 7,
        supplier: "Wood Suppliers Ltd",
        availableQuantity: 45,
      },
      {
        id: "c2",
        lineNumber: 20,
        componentCode: "WOOD-OAK-002",
        componentName: "Oak Wood Legs",
        componentDescription: "Solid oak desk legs",
        quantity: 4,
        unitOfMeasure: "Each",
        unitCost: 22.50,
        totalCost: 90.00,
        scrapPercentage: 2,
        isOptional: false,
        leadTimeDays: 7,
        supplier: "Wood Suppliers Ltd",
        availableQuantity: 120,
      },
      {
        id: "c3",
        lineNumber: 30,
        componentCode: "HARDWARE-001",
        componentName: "Drawer Slides",
        componentDescription: "Heavy duty drawer slides",
        quantity: 6,
        unitOfMeasure: "Pair",
        unitCost: 8.50,
        totalCost: 51.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 3,
        supplier: "Hardware Direct",
        availableQuantity: 200,
      },
      {
        id: "c4",
        lineNumber: 40,
        componentCode: "HARDWARE-002",
        componentName: "Drawer Handles",
        componentDescription: "Brass drawer handles",
        quantity: 6,
        unitOfMeasure: "Each",
        unitCost: 4.25,
        totalCost: 25.50,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 3,
        supplier: "Hardware Direct",
        availableQuantity: 350,
      },
      {
        id: "c5",
        lineNumber: 50,
        componentCode: "FINISH-001",
        componentName: "Wood Varnish",
        componentDescription: "Premium wood varnish",
        quantity: 0.5,
        unitOfMeasure: "Litre",
        unitCost: 28.00,
        totalCost: 14.00,
        scrapPercentage: 10,
        isOptional: false,
        leadTimeDays: 2,
        supplier: "Paint & Finish Co",
        availableQuantity: 25,
      },
    ],
    routing: [
      {
        id: "r1",
        operationNumber: 10,
        operationName: "Cut Wood Panels",
        workCenter: "CNC-01",
        setupTimeMinutes: 30,
        runTimePerUnit: 45,
        laborCostPerHour: 25.00,
        overheadCostPerHour: 15.00,
        description: "Cut and shape wood panels to size",
      },
      {
        id: "r2",
        operationNumber: 20,
        operationName: "Assembly",
        workCenter: "ASSEMBLY-01",
        setupTimeMinutes: 15,
        runTimePerUnit: 120,
        laborCostPerHour: 22.00,
        overheadCostPerHour: 12.00,
        description: "Assemble desk components",
      },
      {
        id: "r3",
        operationNumber: 30,
        operationName: "Finishing",
        workCenter: "FINISH-01",
        setupTimeMinutes: 20,
        runTimePerUnit: 90,
        laborCostPerHour: 20.00,
        overheadCostPerHour: 10.00,
        description: "Apply varnish and final finishing",
      },
    ],
    totalMaterialCost: 265.50,
    totalLaborCost: 145.83,
    totalOverheadCost: 77.50,
    totalCost: 488.83,
    costPerUnit: 488.83,
    createdBy: "John Smith",
    createdDate: new Date("2024-01-01"),
    lastModifiedBy: "John Smith",
    lastModifiedDate: new Date("2024-01-15"),
    approvedBy: "Sarah Johnson",
    approvedDate: new Date("2024-01-10"),
    notes: "Standard production BOM for executive desk",
    usageCount: 24,
    lastUsedDate: new Date("2024-03-15"),
    isMultiLevel: false,
    bomLevel: 0,
  },
  {
    id: "2",
    bomNumber: "BOM-002",
    parentItemCode: "CHAIR-001",
    parentItemName: "Office Chair",
    parentItemDescription: "Ergonomic office chair with adjustable height",
    version: "2.1",
    status: "active",
    effectiveDate: new Date("2024-02-01"),
    expiryDate: null,
    bomType: "assembly",
    baseQuantity: 1,
    unitOfMeasure: "Each",
    components: [
      {
        id: "c6",
        lineNumber: 10,
        componentCode: "CHAIR-BASE-001",
        componentName: "Chair Base Assembly",
        componentDescription: "5-star base with casters",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 35.00,
        totalCost: 35.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 5,
        supplier: "Chair Components Ltd",
        availableQuantity: 80,
      },
      {
        id: "c7",
        lineNumber: 20,
        componentCode: "CHAIR-CYLINDER-001",
        componentName: "Gas Lift Cylinder",
        componentDescription: "Height adjustment cylinder",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 18.50,
        totalCost: 18.50,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 5,
        supplier: "Chair Components Ltd",
        availableQuantity: 150,
      },
      {
        id: "c8",
        lineNumber: 30,
        componentCode: "CHAIR-SEAT-001",
        componentName: "Padded Seat",
        componentDescription: "Ergonomic padded seat with fabric cover",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 42.00,
        totalCost: 42.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 7,
        supplier: "Upholstery Supplies",
        availableQuantity: 60,
      },
      {
        id: "c9",
        lineNumber: 40,
        componentCode: "CHAIR-BACK-001",
        componentName: "Chair Back",
        componentDescription: "Mesh back with lumbar support",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 38.00,
        totalCost: 38.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 7,
        supplier: "Upholstery Supplies",
        availableQuantity: 55,
      },
      {
        id: "c10",
        lineNumber: 50,
        componentCode: "CHAIR-ARMS-001",
        componentName: "Armrests",
        componentDescription: "Adjustable armrests (pair)",
        quantity: 1,
        unitOfMeasure: "Pair",
        unitCost: 24.00,
        totalCost: 24.00,
        scrapPercentage: 0,
        isOptional: true,
        notes: "Optional upgrade",
        leadTimeDays: 5,
        supplier: "Chair Components Ltd",
        availableQuantity: 90,
      },
    ],
    totalMaterialCost: 157.50,
    totalLaborCost: 22.00,
    totalOverheadCost: 8.50,
    totalCost: 188.00,
    costPerUnit: 188.00,
    createdBy: "Mike Wilson",
    createdDate: new Date("2024-01-15"),
    lastModifiedBy: "Mike Wilson",
    lastModifiedDate: new Date("2024-02-01"),
    approvedBy: "Sarah Johnson",
    approvedDate: new Date("2024-01-25"),
    notes: "Updated version with improved ergonomics",
    usageCount: 156,
    lastUsedDate: new Date("2024-03-18"),
    isMultiLevel: false,
    bomLevel: 0,
  },
  {
    id: "3",
    bomNumber: "BOM-003",
    parentItemCode: "LAPTOP-KIT-001",
    parentItemName: "Laptop Starter Kit",
    parentItemDescription: "Complete laptop starter kit for new employees",
    version: "1.0",
    status: "active",
    effectiveDate: new Date("2024-01-01"),
    expiryDate: null,
    bomType: "kit",
    baseQuantity: 1,
    unitOfMeasure: "Each",
    components: [
      {
        id: "c11",
        lineNumber: 10,
        componentCode: "LAPTOP-001",
        componentName: "Business Laptop",
        componentDescription: "15-inch business laptop",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 850.00,
        totalCost: 850.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 3,
        supplier: "Tech Supplies Ltd",
        availableQuantity: 25,
      },
      {
        id: "c12",
        lineNumber: 20,
        componentCode: "MOUSE-001",
        componentName: "Wireless Mouse",
        componentDescription: "Ergonomic wireless mouse",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 25.00,
        totalCost: 25.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 1,
        supplier: "Tech Supplies Ltd",
        availableQuantity: 150,
      },
      {
        id: "c13",
        lineNumber: 30,
        componentCode: "BAG-001",
        componentName: "Laptop Bag",
        componentDescription: "Padded laptop bag",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 35.00,
        totalCost: 35.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 2,
        supplier: "Office Supplies Co",
        availableQuantity: 75,
      },
      {
        id: "c14",
        lineNumber: 40,
        componentCode: "CHARGER-001",
        componentName: "Laptop Charger",
        componentDescription: "Universal laptop charger",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 45.00,
        totalCost: 45.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 2,
        supplier: "Tech Supplies Ltd",
        availableQuantity: 100,
      },
    ],
    totalMaterialCost: 955.00,
    totalLaborCost: 0,
    totalOverheadCost: 0,
    totalCost: 955.00,
    costPerUnit: 955.00,
    createdBy: "Emma Davis",
    createdDate: new Date("2024-01-01"),
    lastModifiedBy: "Emma Davis",
    lastModifiedDate: new Date("2024-01-01"),
    approvedBy: "Sarah Johnson",
    approvedDate: new Date("2024-01-05"),
    notes: "Standard kit for new employee onboarding",
    usageCount: 12,
    lastUsedDate: new Date("2024-03-10"),
    isMultiLevel: false,
    bomLevel: 0,
  },
  {
    id: "4",
    bomNumber: "BOM-004",
    parentItemCode: "CABINET-001",
    parentItemName: "Filing Cabinet",
    parentItemDescription: "4-drawer metal filing cabinet",
    version: "1.0",
    status: "draft",
    effectiveDate: new Date("2024-04-01"),
    expiryDate: null,
    bomType: "manufacturing",
    baseQuantity: 1,
    unitOfMeasure: "Each",
    components: [
      {
        id: "c15",
        lineNumber: 10,
        componentCode: "METAL-SHEET-001",
        componentName: "Steel Sheet",
        componentDescription: "Cold-rolled steel sheet",
        quantity: 2,
        unitOfMeasure: "Sheet",
        unitCost: 45.00,
        totalCost: 90.00,
        scrapPercentage: 8,
        isOptional: false,
        leadTimeDays: 10,
        supplier: "Metal Suppliers Inc",
        availableQuantity: 30,
      },
      {
        id: "c16",
        lineNumber: 20,
        componentCode: "DRAWER-RAILS-001",
        componentName: "Drawer Rails",
        componentDescription: "Heavy-duty drawer rails",
        quantity: 4,
        unitOfMeasure: "Set",
        unitCost: 12.00,
        totalCost: 48.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 5,
        supplier: "Hardware Direct",
        availableQuantity: 80,
      },
      {
        id: "c17",
        lineNumber: 30,
        componentCode: "LOCK-001",
        componentName: "Cabinet Lock",
        componentDescription: "Key lock with 2 keys",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 15.00,
        totalCost: 15.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 3,
        supplier: "Security Hardware Ltd",
        availableQuantity: 120,
      },
      {
        id: "c18",
        lineNumber: 40,
        componentCode: "PAINT-001",
        componentName: "Metal Paint",
        componentDescription: "Powder coat paint - grey",
        quantity: 0.3,
        unitOfMeasure: "Kg",
        unitCost: 35.00,
        totalCost: 10.50,
        scrapPercentage: 5,
        isOptional: false,
        leadTimeDays: 2,
        supplier: "Paint & Finish Co",
        availableQuantity: 50,
      },
    ],
    totalMaterialCost: 163.50,
    totalLaborCost: 0,
    totalOverheadCost: 0,
    totalCost: 163.50,
    costPerUnit: 163.50,
    createdBy: "Tom Brown",
    createdDate: new Date("2024-03-15"),
    lastModifiedBy: "Tom Brown",
    lastModifiedDate: new Date("2024-03-15"),
    notes: "Draft BOM - pending approval",
    usageCount: 0,
    lastUsedDate: null,
    isMultiLevel: false,
    bomLevel: 0,
  },
  {
    id: "5",
    bomNumber: "BOM-005",
    parentItemCode: "WORKSTATION-001",
    parentItemName: "Complete Workstation",
    parentItemDescription: "Complete office workstation with desk and chair",
    version: "1.0",
    status: "active",
    effectiveDate: new Date("2024-02-01"),
    expiryDate: null,
    bomType: "assembly",
    baseQuantity: 1,
    unitOfMeasure: "Each",
    components: [
      {
        id: "c19",
        lineNumber: 10,
        componentCode: "DESK-001",
        componentName: "Executive Desk",
        componentDescription: "Premium executive desk with drawers",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 488.83,
        totalCost: 488.83,
        scrapPercentage: 0,
        isOptional: false,
        notes: "Uses BOM-001",
        leadTimeDays: 14,
        supplier: "Internal",
        availableQuantity: 12,
      },
      {
        id: "c20",
        lineNumber: 20,
        componentCode: "CHAIR-001",
        componentName: "Office Chair",
        componentDescription: "Ergonomic office chair",
        quantity: 1,
        unitOfMeasure: "Each",
        unitCost: 188.00,
        totalCost: 188.00,
        scrapPercentage: 0,
        isOptional: false,
        notes: "Uses BOM-002",
        leadTimeDays: 10,
        supplier: "Internal",
        availableQuantity: 18,
      },
      {
        id: "c21",
        lineNumber: 30,
        componentCode: "MONITOR-001",
        componentName: "24-inch Monitor",
        componentDescription: "Full HD monitor",
        quantity: 2,
        unitOfMeasure: "Each",
        unitCost: 180.00,
        totalCost: 360.00,
        scrapPercentage: 0,
        isOptional: true,
        notes: "Optional dual monitor setup",
        leadTimeDays: 3,
        supplier: "Tech Supplies Ltd",
        availableQuantity: 40,
      },
    ],
    totalMaterialCost: 1036.83,
    totalLaborCost: 15.00,
    totalOverheadCost: 5.00,
    totalCost: 1056.83,
    costPerUnit: 1056.83,
    createdBy: "Sarah Johnson",
    createdDate: new Date("2024-02-01"),
    lastModifiedBy: "Sarah Johnson",
    lastModifiedDate: new Date("2024-02-01"),
    approvedBy: "John Smith",
    approvedDate: new Date("2024-02-05"),
    notes: "Multi-level BOM - contains sub-assemblies",
    usageCount: 8,
    lastUsedDate: new Date("2024-03-12"),
    isMultiLevel: true,
    bomLevel: 0,
  },
  {
    id: "6",
    bomNumber: "BOM-006",
    parentItemCode: "BOOKSHELF-001",
    parentItemName: "Office Bookshelf",
    parentItemDescription: "5-shelf wooden bookshelf",
    version: "1.0",
    status: "inactive",
    effectiveDate: new Date("2023-06-01"),
    expiryDate: new Date("2024-01-31"),
    bomType: "manufacturing",
    baseQuantity: 1,
    unitOfMeasure: "Each",
    components: [
      {
        id: "c22",
        lineNumber: 10,
        componentCode: "WOOD-PINE-001",
        componentName: "Pine Wood Boards",
        componentDescription: "Pine wood boards 1500x300mm",
        quantity: 5,
        unitOfMeasure: "Each",
        unitCost: 18.00,
        totalCost: 90.00,
        scrapPercentage: 3,
        isOptional: false,
        leadTimeDays: 5,
        supplier: "Wood Suppliers Ltd",
        availableQuantity: 200,
      },
      {
        id: "c23",
        lineNumber: 20,
        componentCode: "WOOD-PINE-002",
        componentName: "Pine Wood Sides",
        componentDescription: "Pine wood side panels",
        quantity: 2,
        unitOfMeasure: "Each",
        unitCost: 22.00,
        totalCost: 44.00,
        scrapPercentage: 3,
        isOptional: false,
        leadTimeDays: 5,
        supplier: "Wood Suppliers Ltd",
        availableQuantity: 100,
      },
      {
        id: "c24",
        lineNumber: 30,
        componentCode: "HARDWARE-003",
        componentName: "Shelf Brackets",
        componentDescription: "Metal shelf support brackets",
        quantity: 10,
        unitOfMeasure: "Each",
        unitCost: 2.50,
        totalCost: 25.00,
        scrapPercentage: 0,
        isOptional: false,
        leadTimeDays: 2,
        supplier: "Hardware Direct",
        availableQuantity: 500,
      },
    ],
    totalMaterialCost: 159.00,
    totalLaborCost: 45.00,
    totalOverheadCost: 20.00,
    totalCost: 224.00,
    costPerUnit: 224.00,
    createdBy: "Mike Wilson",
    createdDate: new Date("2023-06-01"),
    lastModifiedBy: "Mike Wilson",
    lastModifiedDate: new Date("2023-12-15"),
    approvedBy: "Sarah Johnson",
    approvedDate: new Date("2023-06-10"),
    notes: "Discontinued - replaced by new design",
    usageCount: 45,
    lastUsedDate: new Date("2024-01-20"),
    isMultiLevel: false,
    bomLevel: 0,
  },
];

// Helper function to get BOM by ID
export function getBOMById(id: string): BOM | undefined {
  return MOCK_BOMS.find(bom => bom.id === id);
}

// Helper function to get BOM by number
export function getBOMByNumber(bomNumber: string): BOM | undefined {
  return MOCK_BOMS.find(bom => bom.bomNumber === bomNumber);
}

// Helper function to get BOMs by parent item code
export function getBOMsByParentItem(parentItemCode: string): BOM[] {
  return MOCK_BOMS.filter(bom => bom.parentItemCode === parentItemCode);
}

// Helper function to get active BOMs
export function getActiveBOMs(): BOM[] {
  return MOCK_BOMS.filter(bom => bom.status === "active");
}

// Helper function to calculate total component cost
export function calculateComponentCost(components: BOMComponent[]): number {
  return components.reduce((sum, component) => sum + component.totalCost, 0);
}
